import React from 'react';
import PropTypes from 'prop-types';

//this.props.classes	: string of classes
//this.props.progress : int of progress
//this.props.layout		: left || right

export default class ProgressBar extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', progress, layout = 'right', color = 'blue', clean = false} = this.props;

		return (
			<div className={"progress-bar " + classes + (layout == 'left' ? " progress-bar--flip" : "")}>
				<div className="progress-bar__bar">
					<div className={"progress-bar__bar-fill progress-bar__bar-fill--" + color} style={{width: progress + '%'}}></div>
				</div>
				{clean ? null : 
					<div className="progress-bar__numeric">{progress}%</div>
				}
			</div>
		);
	}
}

ProgressBar.propTypes = {
		classes: PropTypes.string
	,	progress: PropTypes.number.isRequired
	,	layout: PropTypes.oneOf(['left', 'right'])
	,	color: PropTypes.oneOf(['dark', 'blue', 'green'])
	,	clean: PropTypes.bool
}